
export default function Footer() {
  return (
    <footer className="bg-stone-100 py-16">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-3 gap-12 mb-12">
          {/* Brand */}
          <div className="space-y-6">
            <div className="w-32">
              <img 
                src="https://static.readdy.ai/image/6d9cd499b3569668e27a60fbbc899b03/8646bf9aab5950bd375bfa6dd90695e7.png" 
                alt="DEAIWO" 
                className="w-full h-auto"
              />
            </div>
            <p className="text-sm text-stone-600 leading-relaxed" style={{ fontFamily: 'Noto Serif JP, serif', fontWeight: 400 }}>
              人生に優しく寄り添う
            </p>
          </div>

          {/* Links */}
          <div className="space-y-4">
            <h4 className="text-sm tracking-wide mb-6" style={{ fontFamily: 'Noto Serif JP, serif', fontWeight: 400, color: '#705e44' }}>
              リンク
            </h4>
            <div className="space-y-3">
              <a href="https://www.deaiwo.com/" target="_blank" rel="noopener noreferrer" className="block text-sm text-stone-600 hover:text-[#C6A87B] transition-colors cursor-pointer" style={{ fontFamily: 'Noto Serif JP, serif', fontWeight: 400 }}>
                公式サイト
              </a>
              <a href="https://www.deaiwo.com/" target="_blank" rel="noopener noreferrer" className="block text-sm text-stone-600 hover:text-[#C6A87B] transition-colors cursor-pointer" style={{ fontFamily: 'Noto Serif JP, serif', fontWeight: 400 }}>
                ブランドストーリー
              </a>
              <a href="https://www.deaiwo.com/contact" target="_blank" rel="noopener noreferrer" className="block text-sm text-stone-600 hover:text-[#C6A87B] transition-colors cursor-pointer" style={{ fontFamily: 'Noto Serif JP, serif', fontWeight: 400 }}>
                お問い合わせ
              </a>
            </div>
          </div>

          {/* Contact */}
          <div className="space-y-4">
            <h4 className="text-sm tracking-wide mb-6" style={{ fontFamily: 'Noto Serif JP, serif', fontWeight: 400, color: '#705e44' }}>
              フォロー
            </h4>
            <div className="flex gap-4">
              <a href="https://www.instagram.com/deaiwobrand2025?igsh=MTE2ZjR6bGR0aTRoeA==" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center rounded-full bg-white hover:bg-[#C6A87B] text-stone-600 hover:text-white transition-all cursor-pointer">
                <i className="ri-instagram-line text-lg"></i>
              </a>
              <a href="https://www.tiktok.com/@tsunagoudeaiwo" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center rounded-full bg-white hover:bg-[#C6A87B] text-stone-600 hover:text-white transition-all cursor-pointer">
                <i className="ri-tiktok-line text-lg"></i>
              </a>
              <a href="https://www.youtube.com/@tsunagoudeaiwo" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center rounded-full bg-white hover:bg-[#C6A87B] text-stone-600 hover:text-white transition-all cursor-pointer">
                <i className="ri-youtube-line text-lg"></i>
              </a>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="pt-12 border-t border-stone-200 text-center">
          <p className="text-xs text-stone-500" style={{ fontFamily: 'Noto Serif JP, serif', fontWeight: 400 }}>
            © 2025 Deaiwo. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
